import { styled } from '@mui/material/styles';
import { Color, ColorSAP } from '../../ontego-ui';

// Styled Components
export const DialogSize = styled('div')(({ theme }) => ({
    [theme.breakpoints.between('1280', '1440')]: {
        width: 1200,
    },
    [theme.breakpoints.up('1440')]: {
        width: '90vw',
    },
}));

export const FunctionListCardsContainer = styled('div')({
    maxWidth: 365,
    boxSizing: 'border-box',
    height: '746px',
    overflowY: 'hidden',

    "@media (max-width: 1280px)": {
        height: 442,
    },
});

export const FunctionListContainerTitle = styled('div')({
    width: '95%',
});

export const FunctionListContainer = styled('div')({
    display: 'flex',
    alignItems: 'start',
    width: '100%',
    marginTop: 20,
});

export const FunctionList = styled('div')({
    flex: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflow: '-moz-scrollbars-vertical',
    paddingRight: 18,
    height: "calc(744px - 100px)",
    '&::-webkit-scrollbar': {
        webkitAppearance: 'none',
        width: 7,
    },
    '&::-webkit-scrollbar-thumb': {
        borderRadius: 8,
        backgroundColor: Color.neutral[300],
        webkitBoxShadow: '0 0 1px rgba(255, 255, 255, 0.5)',
    },
    "@media (max-width: 1280px)": {
        height: 342,
    },
});

export const FunctionListItems = styled('div')({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'start',
});

const UpAndRunningCardsBase = styled("div")({
    background: ColorSAP.primary[10],
    flexGrow: 1,
    borderRadius: 16,
    height: "746px",
    overflowX: 'auto',
    position: 'relative',
    display: "flex",
    flexDirection: "column",
    marginLeft: 22,

    "@media (max-width: 1280px)": {
        height: 442,
    },
})

export const UpAndRunningCardsContainer = styled(UpAndRunningCardsBase)({
    border: `1px solid ${ColorSAP.primary[20]}`,
    overflowY: 'auto',
});

export const UpAndRunningCardsContainerEmpty = styled(UpAndRunningCardsBase)({
    alignItems: 'center',
    justifyContent: 'center',
});

export const UpAndRunningListContainerEmpty = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
});

export const UpAndRunningListContainer = styled('div')({
    position: 'relative',
    display: 'flex',
    alignItems: 'start',
    // width: '100%',
    padding: 24,
});

export const UpAndRunningList = styled('div')({
    flex: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: 'fit-content',
    '&::-webkit-scrollbar': {
        webkitAppearance: 'none',
        width: 7,
    },
    '&::-webkit-scrollbar-thumb': {
        borderRadius: 8,
        backgroundColor: Color.neutral[300],
        webkitBoxShadow: '0 0 1px rgba(255, 255, 255, 0.5)',
    },
});

export const UpAndRunningListItems = styled('div')({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'start',
    marginRight: '2%',
});
